<template>
  <div class="image-library-list">
    <b-card class="card-content">
      <!-- class="email-user-list scroll-area" -->
      <b-button
        variant="flat-primary"
        size="sm"
        class="btn-close"
        @click="$emit('close')"
      >
        <feather-icon icon="XIcon" />
      </b-button>
      <b-tabs v-model="tabIndex" class="tab-midia">
        <b-tab>
          <template #title>
            <span>{{$t('MEDIA_LIBRARY.Title')}}</span>
            <b-badge variant="light-secondary" class="total-files">{{
              totalRows
            }}</b-badge>
          </template>
          <b-card>
            <b-row class="filters">
              <b-col md="4">
                <v-select
                  id="filter"
                  v-model="filterModel"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  multiple
                  taggable
                  :placeholder="$t('MEDIA_LIBRARY.Browse_Text')"
                  push-tags
                  @input="inputFilter"
                />
              </b-col>
              <b-col md="5">
                <v-select
                  id="filter-extension"
                  v-model="filterExtension"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  multiple
                  taggable
                  push-tags
                  :placeholder="$t('MEDIA_LIBRARY.Media_Type')"
                  :options="extensions"
                  @input="inputFilterExtensions"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="9" class="pr-0 media-gallery">
                <vue-perfect-scrollbar
                  :settings="perfectScrollbarSettings"
                  :suppressScrollX="true"
                  @ps-y-reach-end="tabIndex === 0 && scrollHandleToEnd()"
                >
                  <b-row class="row-fluid">
                    <b-col
                      class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-5 images-separated"
                      xl="2"
                      v-for="image in data"
                      :key="image._id"
                      @click="onSelectImage(image)"
                    >
                      <b-img
                        thumbnail
                        fluid
                        class="image-gal"
                        :src="getImgPath(image)"
                        :class="imgClasses(image)"
                      />
                    </b-col>
                    <div class="no-results" v-if="data.length == 0">
                      <span class="not-found">
                        <b-alert
                          v-height-fade.appear
                          variant="danger"
                          :show="data.length == 0"
                          class="mb-0"
                        >
                          <div class="alert-body">
                            <feather-icon icon="InfoIcon" class="mr-50" />
                            {{$t('MEDIA_LIBRARY.Notfound')}}
                          </div>
                        </b-alert>
                      </span>
                    </div>
                  </b-row>
                </vue-perfect-scrollbar>
              </b-col>
              <b-col cols="3" class="pr-2 media-details">
                <b-row>
                  <b-col md="12">
                    <h5>{{$t('MEDIA_LIBRARY.Filename')}}</h5>
                    <b-form-input
                      style="margin-bottom: 10px"
                      id="image_filename"
                      :placeholder="$t('MEDIA_LIBRARY.Filename')"
                      v-model="imageSelected.image_filename"
                      disabled
                    />
                    <b-form-input
                      style="margin-bottom: 0;"
                      id="image_filename"
                      :placeholder="$t('MEDIA_LIBRARY.Filename')"
                      v-model="imageSelected.original_filename"
                      disabled
                    />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <h5>{{$t('MEDIA_LIBRARY.Extension')}}</h5>
                    <b-form-input
                      id="extensions"
                      :placeholder="$t('MEDIA_LIBRARY.Media_Type')"
                      v-model="imageSelected.extension"
                      disabled
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <h5>{{$t('MEDIA_LIBRARY.File_Url')}}</h5>
                    <b-form-input
                      id="image_path"
                      disabled
                      :placeholder="$t('MEDIA_LIBRARY.File_Url')"
                      v-model="imageSelected.image_path"
                      @click="onCopy"
                    />

                    <!-- <b-button
                        v-if="imageSelected.image_path"
                        variant="flat-primary"
                        class="btn-icon rounded-circle"
                        @click="onCopy"
                      >
                        <feather-icon icon="ClipboardIcon" />
                      </b-button> -->
                  </b-col>
                  <b-col md="12" style="display:none;">
                    <b-form-input
                      id="email_create"
                      placeholder="Usuário"
                      v-model="imageSelected.email_create"
                      disabled
                    />
                  </b-col>
                </b-row>
                <hr />
                <b-card class="card-form">
                  <b-row>
                    <b-col md="12">
                      <label for="img-copyright">{{$t('MEDIA_LIBRARY.Copyright')}}</label>
                      <b-form-input
                        id="img-copyright"
                        :placeholder="$t('MEDIA_LIBRARY.Copyright')"
                        v-model="imageSelected.copyright"
                        :disabled="sendNews"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <label for="tag-list">{{$t('MEDIA_LIBRARY.Tags')}}</label>
                      <v-select
                        id="tag-list"
                        v-model="imageSelected.tags"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :placeholder="$t('MEDIA_LIBRARY.Tags')"
                        multiple
                        taggable
                        push-tags
                        :disabled="sendNews"
                      />
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col md="12">
                      <label for="image_type">Tipo de mídia</label>
                      <v-select
                        id="image_type"
                        v-model="imageSelected.image_type"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        placeholder="Tipo de mídia"
                        :options="image_type"
                      />
                    </b-col>
                  </b-row> -->
                  <b-row style="display:none">
                    <b-col md="12">
                      <b-form-group>
                        <b-form-checkbox
                          id="active"
                          name="active"
                          v-model="imageSelected.active"
                        >
                          Ativo
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="!sendNews">
                    <b-col md="12" class="buttons-details">
                      <b-button
                        v-if="imageSelected._id"
                        variant="flat-danger"
                        size="sm"
                        @click="onDelete(imageSelected)"
                        >{{$t('MEDIA_LIBRARY.Delete')}}</b-button
                      >
                      <b-button
                        v-if="imageSelected._id"
                        variant="primary"
                        size="sm"
                        @click="onEdit"
                        >{{$t('MEDIA_LIBRARY.Update')}}</b-button
                      >
                    </b-col>
                  </b-row>
                  <b-row v-if="sendNews">
                    <b-col md="12" class="inserir-midia">
                      <b-button
                        v-if="imageSelected._id"
                        variant="primary"
                        size="sm"
                        @click="onSubmitMedia"
                        >{{$t('MEDIA_LIBRARY.Insert_Media')}}</b-button
                      >
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab :title="$t('MEDIA_LIBRARY.Tab_Upload')">
          <image-library-register :ref="`${instance}-image-library-register`" :sendNews="sendNews" :selectedTags="tags" @back="selectToList" @select-new-image="onSubmitNewMedia"></image-library-register>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BImg,
  BTab,
  BTabs,
  BBadge,
  BFormInput,
  BButton,
  BFormCheckbox,
  BAlert,
} from "bootstrap-vue";
// import AppConstants from "@/appConstants";
import useImageLib from "./useImageLib";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
// import { computed } from '@vue/composition-api';
import { ref } from "@vue/composition-api";
import store from "@/store";
import { formatDate } from "@core/utils/filter";
import vSelect from "vue-select";
import ImageLibraryRegister from "./image-library-register/ImageLibraryRegister.vue";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import AppConstants from "@/appConstants";
import { heightFade } from '@core/directives/animations'

export default {
  components: {
    ImageLibraryRegister,
    vSelect,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BImg,
    BTab,
    BTabs,
    BBadge,
    BFormInput,
    BButton,
    BFormCheckbox,
    VuePerfectScrollbar,
    BAlert,
  },
  directives: {
    'height-fade': heightFade,
  },
  props: {
    sendNews: {
      type: Boolean,
      require: true,
    },
    tags: {
      type: Array,
    },
    selectedItens: {
      type: Object,
    },
    dataType: {
      type: String,
    },
    instance: {
      type: String
    }
  },
  created() {
    if (this.sendNews && this.tags) {
      if (this.tags.length > 0) {
        this.onFilter(this.tags.map((item) => {
          if (item.name) {
            return item.name;
          }
          return item;
        }));
      }
    }
    if (this.sendNews && this.selectedItens) {
      this.onSelectImage(this.selectedItens);
    }

  },
  computed: {

  },
  methods: {
    onPaste(data) {
      this.$refs[`${this.instance}-image-library-register`].onSelectedFileImage(null, data);
      this.tabIndex = 1;
    },
    imgClasses(data) {
      const classes = [];
      if (this.isImageSelected(data)) {
        classes.push("image-selected");
      }
      if (AppConstants.MEDIA_DOCUMENT_EXTENSIONS.indexOf(data.extension) >= 0) {
        classes.push(`img-${data.extension}`);
      }
      return classes;
    },
    getImgPath(data) {
      if (AppConstants.MEDIA_DOCUMENT_EXTENSIONS.indexOf(data.extension) >= 0 || AppConstants.MEDIA_AUDIO_EXTENSIONS.indexOf(data.extension) >= 0) {
        const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(
          (item) => item.values.indexOf(data.extension) >= 0
        );
        if (doc) {
          return require(`@/assets/images/icons/${doc.img_name}`);
        }
      }
      return data.image_path;
    },
    onSubmitNewMedia(data) {
      this.imageSelected = data;
      this.onSubmitMedia();
    },
    onSubmitMedia() {
      this.$emit("submit-document", this.imageSelected);
    },
    selectToList() {
      this.tabIndex--;
      this.fetchImages();
    },
    onCopy() {
      this.$copyText(this.imageSelected.image_path).then(() => {
        messagesNotifyHelper.successNotify("URL", "URL copiada com sucesso");
      });
    },
    // onEdit(data) {
    //   this.$router.push(
    //     `${AppConstants.NAVIGATION_PAGE_IMAGE_LIBRARY_REGISTER}/${data._id}`
    //   );
    // },
  },
  setup(props) {
    const tabIndex = ref(0);

    // let origins = computed(
    //   () => store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].origins
    // );

    const {
      data,
      totalRows,
      limit,
      filterFields,
      perfectScrollbarSettings,
      perfectScrollbarReachEnd,
      displayLoading,
      fetchImages,
      onFilter,
      onClearFilter,
      onChangePage,
      onDelete,
      scrollHandleToEnd,
      inputFilter,
      inputFilterExtensions,
      imageSelected,
      isImageSelected,
      onSelectImage,
      onEdit,
      extensions,
      filterExtension,
      filterModel,
      displayAlert,
      initFilter,
    } = useImageLib();

    if (props.sendNews) {
      initFilter(props.dataType);
    } else {
      store.state[AppConstants.IMAGE_LIBRARY_STORE_MODULE_NAME].filter = [];
    }
    if (tabIndex.value === 0) {
      fetchImages();
    }

    return {
      tabIndex,
      data,
      totalRows,
      limit,
      filterFields,
      perfectScrollbarSettings,
      perfectScrollbarReachEnd,
      displayLoading,
      fetchImages,
      onFilter,
      onClearFilter,
      onChangePage,
      onDelete,
      scrollHandleToEnd,
      formatDate,
      inputFilter,
      inputFilterExtensions,
      imageSelected,
      isImageSelected,
      onSelectImage,
      onEdit,
      extensions,
      filterExtension,
      filterModel,
      displayAlert,
      // current file data
      // origins,
    };
  },
};
</script>
